import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faCar } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@services/auth/auth.service';
import { UiService } from '@services/category-lists/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends SubscriptionBaseComponent implements OnInit {

  faCar = faCar;

  loginForm: FormGroup;
  isLoading: boolean;

  constructor(
    private authSrv: AuthService,
    private uiSrv: UiService,
    private formBuilder: FormBuilder
  ) {
    super();
  }

  ngOnInit() {
    this.initForm();
    this.initSubscriptions();
  }

  onSubmit(): void {
    this.isLoading = true;
    this.authSrv.login(this.loginForm.value);
  }

  private initForm(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  private initSubscriptions(): void {
    this.isLoading = false;

    this.subscription.add(
      this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
          this.isLoading = loadingState;
        })
    );
  }
}
